import { render, staticRenderFns } from "./StepFour.vue?vue&type=template&id=5d168ab7&scoped=true&"
import script from "./StepFour.vue?vue&type=script&lang=js&"
export * from "./StepFour.vue?vue&type=script&lang=js&"
import style0 from "./StepFour.vue?vue&type=style&index=0&id=5d168ab7&lang=scss&scoped=true&"
import style1 from "./StepFour.vue?vue&type=style&index=1&id=5d168ab7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d168ab7",
  null
  
)

export default component.exports